import {IdPrefix} from './idHelpers.enums';
import {feedIdPrefixes, strategyIdPrefixes} from './idHelpers.consts';
import toId from './utils/toId';
import parseId from './utils/parseId';

export const idPrefixToEntityName: Record<IdPrefix, string> = {
  [IdPrefix.Card]: 'card',
  [IdPrefix.Output]: 'output',
  [IdPrefix.ProductFeed]: 'product feed',
  [IdPrefix.LocationFeed]: 'location feed',
  [IdPrefix.ContentFeed]: 'content feed',
  [IdPrefix.ProductSet]: 'product set',
  [IdPrefix.LocationSet]: 'location set',
  [IdPrefix.TopItems]: 'top items',
  [IdPrefix.CategoryTopItems]: 'category top items',
  [IdPrefix.ContentSet]: 'content set',
  [IdPrefix.Creative]: 'creative',
  [IdPrefix.Dsp]: 'DSP',
  [IdPrefix.ProductStrategy]: 'product strategy',
  [IdPrefix.LocationStrategy]: 'location strategy',
  [IdPrefix.ContentStrategy]: 'content strategy',
};

export const idHelper = {
  toCardId: (id: number) => toId(IdPrefix.Card, id),
  toOutputId: (id: number) => toId(IdPrefix.Output, id),
  toProductFeedId: (id: number) => toId(IdPrefix.ProductFeed, id),
  toLocationFeedId: (id: number) => toId(IdPrefix.LocationFeed, id),
  toContentFeedId: (id: number) => toId(IdPrefix.ContentFeed, id),
  toProductSetId: (id: number) => toId(IdPrefix.ProductSet, id),
  toLocationSetId: (id: number) => toId(IdPrefix.LocationSet, id),
  toTopItemsId: (id: number) => toId(IdPrefix.TopItems, id),
  toCategoryTopItemsId: (id: number) => toId(IdPrefix.CategoryTopItems, id),
  toContentSetId: (id: number) => toId(IdPrefix.ContentSet, id),
  toCreativeId: (id: number) => toId(IdPrefix.Creative, id),
  toDspId: (id: number) => toId(IdPrefix.Dsp, id),
  toProductStrategyId: (id: number) => toId(IdPrefix.ProductStrategy, id),
  toLocationStrategyId: (id: number) => toId(IdPrefix.LocationStrategy, id),
  toContentStrategyId: (id: number) => toId(IdPrefix.ContentStrategy, id),

  parseCardId: (raw: string) => parseId(raw, IdPrefix.Card),
  parseOutputId: (raw: string) => parseId(raw, IdPrefix.Output),
  parseProductFeedId: (raw: string) => parseId(raw, IdPrefix.ProductFeed),
  parseLocationFeedId: (raw: string) => parseId(raw, IdPrefix.LocationFeed),
  parseContentFeedId: (raw: string) => parseId(raw, IdPrefix.ContentFeed),
  parseProductSetId: (raw: string) => parseId(raw, IdPrefix.ProductSet),
  parseLocationSetId: (raw: string) => parseId(raw, IdPrefix.LocationSet),
  parseTopItemsId: (raw: string) => parseId(raw, IdPrefix.TopItems),
  parseCategoryTopItemsId: (raw: string) => parseId(raw, IdPrefix.CategoryTopItems),
  parseContentSetId: (raw: string) => parseId(raw, IdPrefix.ContentSet),
  parseCreativeId: (raw: string) => parseId(raw, IdPrefix.Creative),
  parseDspId: (raw: string) => parseId(raw, IdPrefix.Dsp),
  parseProductStrategyId: (raw: string) => parseId(raw, IdPrefix.ProductStrategy),
  parseLocationStrategyId: (raw: string) => parseId(raw, IdPrefix.LocationStrategy),
  parseContentStrategyId: (raw: string) => parseId(raw, IdPrefix.ContentStrategy),
  parseFeedId: (raw: string) => parseId(raw, feedIdPrefixes),
  parseStrategyId: (raw: string) => parseId(raw, strategyIdPrefixes),
};
